import { useMemo } from 'react';
import { Card, Table } from 'react-bootstrap';
//import { Appointment } from './types/appointment.tsx';
import { DraggableAppointment } from './DraggableAppointment.js';
import { DroppableCell } from './DroppableCell.tsx';
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  isSameMonth,
  isSameDay,
  isToday,
  format,
} from 'date-fns';


const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export function MonthView({ currentDate, appointments, onDateClick }) {

  console.log(appointments)
  const calendarDays = useMemo(() => {
    const monthStart = startOfMonth(currentDate);
    const monthEnd = endOfMonth(currentDate);
    const calendarStart = startOfWeek(monthStart);
    const calendarEnd = endOfWeek(monthEnd);

    return eachDayOfInterval({ start: calendarStart, end: calendarEnd });
  }, [currentDate]);

  const getAppointmentsForDay = (day) => {

    console.log(day)
    console.log(appointments)

    return appointments.filter((apt) => isSameDay(apt.date, day));
  };

  const weeks = useMemo(() => {
    const result = [];
    for (let i = 0; i < calendarDays.length; i += 7) {
      result.push(calendarDays.slice(i, i + 7));
    }
    return result;
  }, [calendarDays]);

  return (
    <Card className="shadow-sm animate-fade-in overflow-hidden">
      <Table bordered className="mb-0">
        <thead className="bg-light">
          <tr>
            {weekDays.map((day) => (
              <th key={day} className="text-center text-muted py-3 fw-medium" style={{ width: '14.28%' }}>
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, weekIndex) => (
            <tr key={weekIndex}>
              {week.map((day) => {
                const dayAppointments = getAppointmentsForDay(day);
                const isCurrentMonth = isSameMonth(day, currentDate);
                const isDayToday = isToday(day);

                return (
                  <td
                    key={day.toISOString()}
                    className="p-0 align-top"
                  >
                    <DroppableCell
                      id={`month-day-${format(day, 'yyyy-MM-dd')}`}
                      date={day}
                      onClick={() => onDateClick?.(day)}
                      className={`h-100 p-2 month-cell ${!isCurrentMonth ? 'calendar-other-month' : ''} ${isDayToday ? 'calendar-today' : ''}`}
                    >
                      <div
                        className={`day-number mb-1 ${isDayToday ? 'day-number-today' : ''} ${!isCurrentMonth ? 'text-muted' : ''}`}
                      >
                        {format(day, 'd')}
                      </div>

                      <div className="overflow-hidden">
                        {dayAppointments.slice(0, 3).map((apt) => (
                          <DraggableAppointment key={apt.id} appointment={apt} compact />
                        ))}
                        {dayAppointments.length > 3 && (
                          <small className="text-primary fw-medium px-1">
                            +{dayAppointments.length - 3} mais
                          </small>
                        )}
                      </div>
                    </DroppableCell>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
}
